import { createSimpleFunctional } from '@/util'

export const VListItemTitle = createSimpleFunctional('v-list-item-title')
